import { formatRefDate } from '../../../utils/formatRefDate';
import { Button, DatePicker, Form, Input, Select, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { ArrowRightOutlined, SearchOutlined } from '@ant-design/icons';
import { GetHistorical, GetHistoricalBunker, GetLastSPAL } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterRDSPALNOW = ({ onData, onDataToleransi, onLoading }) => {

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    // const [loadings, setLoadings] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const [dataSPAL, setDataSPAL] = useState([]);
    const [selectedSPAL, setSelectedSPAL] = useState(null);

    const fetchDataReading = async (start, end) => {
        try {
            setIsLoading(true);
            onLoading(true);
            // const response = await GetHistorical(KodeCabang, ShipCode, start, end, onDataToleransi[0], onDataToleransi[1]);
            const [response] = await GetHistoricalBunker({
                AccountId: KodeCabang,
                ObjectCode: ShipCode,
                StartDate: start,
                EndDate: end,
            });
            // console.log(response);
            onData(response);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            onLoading(false);
        }
    };

    useEffect(() => {
        const fetchLastSPAL = async () => {
            try {
                const response = await GetLastSPAL(KodeCabang, ShipCode, 0);

                if (response) {
                    setDataSPAL(response);

                    if (response.length > 0) {
                        const defaultSPAL = response[0];
                        const StartDate = dayjs.utc(defaultSPAL.StartDate).format('YYYY-MM-DD HH:mm:ss');
                        const EndDate = dayjs().format('YYYY-MM-DD HH:mm:ss');
                        setSelectedSPAL(defaultSPAL);
                        form.setFieldsValue({
                            SPAL: defaultSPAL.SONumber,
                            RangeDate: [
                                dayjs(StartDate),
                                dayjs(EndDate),
                            ],
                        });
                        fetchDataReading(StartDate, EndDate);
                    }
                } else {
                    console.error("Response does not contain an array for SPAL");
                }
            } catch (error) {
                console.error("Error fetching SPAL data:", error);
            }
        };
        fetchLastSPAL();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [KodeCabang, ShipCode, form]);

    const handleSPALChange = (value) => {
        setSelectedSPAL(value);
        // Opsional: Jika ingin mengubah rentang tanggal berdasarkan SPAL yang dipilih
        const selectedSPALData = dataSPAL.find(item => item.SONumber === value);
        if (selectedSPALData && selectedSPALData.StartDate) {
            const StartDate = dayjs.utc(selectedSPALData.StartDate).format('YYYY-MM-DD HH:mm:ss');
            const EndDate = dayjs().format('YYYY-MM-DD HH:mm:ss');

            form.setFieldsValue({
                RangeDate: [dayjs(StartDate), dayjs(EndDate)],
            });
        }
    };

    const onSubmit = async (values) => {
        const { RangeDate } = values;

        const startDateRange = RangeDate ? dayjs(RangeDate[0]).format('YYYY-MM-DD HH:mm:ss') : null;
        const endDateRange = RangeDate ? dayjs(RangeDate[1]).format('YYYY-MM-DD HH:mm:ss') : null;

        fetchDataReading(startDateRange, endDateRange);
    };

    return (
        <div>
            <Form
                layout="vertical"
                onFinish={onSubmit}
                form={form}
                initialValues={{
                    SPAL: selectedSPAL,
                }}
            >
                <div className="analytics-filter">
                    <div className="analytics-filter-fields">
                        <Form.Item
                            name="SPAL" label="SPAL / Voyage"
                        >
                            <Select
                                onChange={(value) => setSelectedSPAL(value)}
                                className="w-full"
                                placeholder="Select SPAL"
                                popupMatchSelectWidth={true}
                                popupClassName="analytics-select-popup"
                                disabled={isLoading}
                                optionLabelProp="label"
                                options={(dataSPAL || []).map((item) => ({
                                    value: item.SONumber,
                                    label: item.SONumber,
                                    ...item,
                                }))}
                                optionRender={(option) => {
                                    const item = option.data;
                                    return (
                                        <div className="flex flex-col gap-1.5 py-0.5 analytics-option">
                                            <div className="flex items-center justify-between gap-3">
                                                <span className="text-sm font-semibold text-gray-800">{item.SONumber}</span>
                                                <span className={`shrink-0 text-[10px] leading-none px-2 py-1 rounded-full font-medium ${item.IsFinish ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`}>
                                                    {item.IsFinish ? 'FINISH' : 'UNFINISHED'}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-blue-50 text-blue-700 text-xs font-medium">
                                                    <span className="text-[9px] uppercase tracking-wide text-blue-400">Load</span>
                                                    {item.LoadPositionName}
                                                </span>
                                                <ArrowRightOutlined className="text-[10px] text-gray-400" />
                                                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-orange-50 text-orange-700 text-xs font-medium">
                                                    <span className="text-[9px] uppercase tracking-wide text-orange-400">Unload</span>
                                                    {item.UnloadPositionName}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                        </Form.Item>

                        <Input
                            readOnly
                            disabled={isLoading}
                            className="w-full"
                            placeholder="Load Position"
                            addonBefore="Load"
                            value={selectedSPAL?.LoadPositionName || ''}
                        />
                        <Input
                            readOnly
                            disabled={isLoading}
                            className="w-full"
                            placeholder="Unload Position"
                            addonBefore="Unload"
                            value={selectedSPAL?.UnloadPositionName || ''}
                        />

                        <Form.Item
                            name="RangeDate" label="Date Range"
                        >
                            <RangePicker
                            popupClassName="analytics-date-popup"
                                showTime={{
                                    format: 'HH:mm:ss',
                                }}
                                format={(value) => formatRefDate(value.format('YYYY-MM-DD HH:mm:ss'))}
                                disabled={true}
                            />
                        </Form.Item>
                    </div>
                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={isLoading}>Apply</Button>
                </div>
            </Form >
        </div>
    );
}

export default FilterRDSPALNOW;
